import { StoreDetailsInfo } from "../constants/StoreDetails";
import { IAllCategoriesResponse } from "../types/Categories.types";
import { IStoreAddress } from "../types/StoreDetails.types";

const { SUFFIX_MORE } = StoreDetailsInfo;

export const handleGetFullAddress = (storeAddress: IStoreAddress) => {
  if (storeAddress && Object?.keys?.(storeAddress)) {
    const { address, state, postalCode, city } = storeAddress;
    return `${address}, ${city} ${state}, ${postalCode}`;
  }
};

export const handleViewCategories = (
  categoriesList: IAllCategoriesResponse[],
  categories: string[]
) => {
  if (categoriesList?.length && categories?.length) {
    const firstCategoryId = categories[0];
    const firstCategory = categoriesList.find(({ id }) => id === firstCategoryId);
    const firstCategoryName = firstCategory && firstCategory.name;
    return categories?.length > 1
      ? `${firstCategoryName} + ${categories?.length - 1} ${SUFFIX_MORE}`
      : firstCategoryName;
  }
};